export const COLORSPACE_OPTIONS = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'RGB',
        value: 'rgb',
    },
    {
        name: 'FORCE_RGB',
        value: 'force_rgb',
    },
    {
        name: 'CMYK',
        value: 'cmyk',
    },
    {
        name: 'FORCE_CMYK',
        value: 'force_cmyk',
    },
]

export const PRINTER_OPTIONS = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'SBC',
        value: 'SBC',
    },
    {
        name: 'Dlican',
        value: 'Dlican',
    },
]
